import React from 'react';
import { GraduationCap, Award as AwardIcon, Trophy, Calendar, MapPin } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Education = () => {
  const { education, achievements } = portfolioData;

  const iconMap = {
    award: AwardIcon,
    trophy: Trophy
  };

  return (
    <section id="education" className="section-padding">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="section-label">Background</span>
          <h2 className="section-title">
            Education & <span className="text-accent">Awards</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-8">
          {/* Education Card */}
          <div
            className="p-8 rounded-2xl border"
            style={{
              background: 'var(--bg-card)',
              borderColor: 'var(--border)'
            }}
          >
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: 'var(--accent)' }}>
                <GraduationCap className="h-8 w-8" style={{ color: '#000' }} />
              </div>
              
              <div className="flex-1">
                <div className="mb-4">
                  <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                    {education.degree}
                  </h3>
                  <p className="text-lg mb-2" style={{ color: 'var(--accent)' }}>{education.major}</p>
                  <p style={{ color: 'var(--text-secondary)' }}>{education.institution}</p>
                </div>
                
                <div className="flex flex-wrap items-center gap-4 text-sm" style={{
                  color: 'var(--text-muted)',
                  fontFamily: 'JetBrains Mono, monospace'
                }}>
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4" />
                    <span>{education.location}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4" />
                    <span>{education.period}</span>
                  </div>
                  <div className="px-3 py-1 rounded-full" style={{ background: 'var(--accent)', color: '#000' }}>
                    CGPA: {education.cgpa}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Achievements */}
          <div className="grid md:grid-cols-2 gap-6">
            {achievements.map((achievement) => {
              const Icon = iconMap[achievement.icon] || AwardIcon;
              return (
                <div
                  key={achievement.id}
                  className="p-6 rounded-2xl border"
                  style={{
                    background: 'var(--bg-card)',
                    borderColor: 'var(--border)'
                  }}
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: 'var(--accent)' }}>
                      <Icon className="h-6 w-6" style={{ color: '#000' }} />
                    </div>
                    
                    <div className="flex-1">
                      <div className="flex items-start justify-between gap-2 mb-2">
                        <h4 className="font-semibold" style={{ color: 'var(--text-primary)' }}>{achievement.title}</h4>
                        <span className="text-xs" style={{
                          color: 'var(--text-muted)',
                          fontFamily: 'JetBrains Mono, monospace'
                        }}>
                          {achievement.date}
                        </span>
                      </div>
                      <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>{achievement.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
